import { connect } from 'react-redux';
import FacilitiesContainer from './FacilitiesContainer';
import {
  getHotelFacilitiesTerritory,
  getHotelFacilitiesKids,
  getHotelFacilitiesAttractions,
  getHotelFacilitiesRoom,
} from '../../store/hotel';

const mapStateToProps = (state) => ({
  territory: getHotelFacilitiesTerritory(state),
  kids: getHotelFacilitiesKids(state),
  attractions: getHotelFacilitiesAttractions(state),
  room: getHotelFacilitiesRoom(state),
});

export default connect(mapStateToProps)(FacilitiesContainer);
